import React from 'react';
import PropTypes from 'prop-types';
import ProtectMask from './css';

const AvoidChangesMask = (props) => {
  const { active, onClick } = props;

  if (active) {
    return (
      <ProtectMask onClick={onClick} />
    );
  }

  return null;
};

AvoidChangesMask.propTypes = {
  active: PropTypes.bool,
  onClick: PropTypes.func,
};

export default AvoidChangesMask;
